import { ClimateIndexType } from 'helper/Meteorology/climateIndicesLabels';
import { IndiceClimaticoField } from 'types/Meteorology/indicesClimaticos';

export interface ClimateIndexConfig {
  id: IndiceClimaticoField;
  abbr: string;
  label: string;
  type: ClimateIndexType;
}

const INDICES: ClimateIndexConfig[] = [
  {
    id: 'nino3.4', abbr: 'NIÑO', label: 'NIÑO 3.4', type: 'nino3.4',
  },
  {
    id: 'iod', abbr: 'IOD', label: 'IOD', type: 'default',
  },
  {
    id: 'tna', abbr: 'TNA', label: 'TNA', type: 'default',
  },
  {
    id: 'tsa', abbr: 'TSA', label: 'TSA', type: 'default',
  },
  {
    id: 'amo', abbr: 'AMO', label: 'AMO', type: 'default',
  },
  {
    id: 'pdo', abbr: 'PDO', label: 'PDO', type: 'default',
  },
  {
    id: 'aao', abbr: 'AAO', label: 'AAO', type: 'aao',
  },
];

export default INDICES;
